import { List, Map, Record } from 'immutable';

import CompanyRecord from 'records/company';
import EmailSettingsRecord from 'records/emailSettings';
import ListingRecord from 'records/listing';
import PageRecord from 'records/page';
import ProductRecord from 'records/product';

export default Record({
    applications: List([]),
    boost: null,
    company: CompanyRecord(Map({})),
    companyId: null,
    dailyLimit: null,
    discountPrice: null,
    emailsCollectedCount: null,
    emailSettings: EmailSettingsRecord(Map({})),
    endsAt: '',
    featuredOn: List([]),
    features: List([]),
    flags: [],
    followups: List([]),
    id: null,
    impressionTotals: Map({}),
    isExclusive: false,
    isMultiUse: false,
    isSingleUse: false,
    isSyndicated: null,
    isUnderperforming: false,
    limit: 0,
    listing: ListingRecord(Map({})),
    maxQuantityDisclaimer: false,
    metadata: Map({}),
    multiUsePromotion: Map({}),
    name: '',
    note: null,
    ordersCount: null,
    page: PageRecord(Map({})),
    product: ProductRecord(Map({})),
    recentOrdersCount: null,
    remainingQuantity: null,
    requireEmail: true,
    returnAt: null,
    singleUsePromotions: List([]),
    startsAt: '',
    state: null,
    timezone: 'US/Pacific',
    type: '',
});



// WEBPACK FOOTER //
// ./src/records/campaign.js